import React from 'react';
import BasePaymentsPage from './BasePaymentsPage';

const PaymentsPage = () => <BasePaymentsPage shouldListenForResize />;

PaymentsPage.displayName = 'PaymentsPage';

export default PaymentsPage;
